<template>
  <div id="app">
    <div class="bgnew" :style="{ opacity: opacity }"></div>
    <div class="bgnew2"></div>

    <div class="wrap">
      <div class="header">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="" />
          <span class="logo-text">工具导航</span>
        </div>
        <nav class="effect">
          <ul>
            <li>
              <a href="https://www.intolearn.com/css/" target="_blank"
                >css-playground</a
              >
            </li>
            <li><a href="/">申请收录</a></li>
            <li><a href="/">纠错/建议</a></li>
          </ul>
        </nav>
      </div>
      <div class="title">Never waste Hours on finding the website again!</div>
      <div class="category">
        <template v-for="(category, i) in categories">
          <div class="item" :key="i" @click="navigateTo(category)">
            {{ category.name }}
          </div>
        </template>
        <div class="item add" @click="dialogVisible = true">
          <i class="el-icon-plus"></i>
        </div>
      </div>
      <div class="fixed-category">
        <template v-for="(category, i) in categories">
          <div class="item" :key="i" @click="navigateTo(category)">
            {{ category.name }}
          </div>
        </template>
      </div>
    </div>
    <router-view />
    <el-dialog
      title="自定义分类"
      :visible.sync="dialogVisible"
      width="370px"
      @close="handleClose"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="网站Logo">
          <el-input v-model="form.icon"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="排序">
          <el-input v-model="form.sort"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCategory">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { defaultNav } from "@/assets/nav-data.js";
import { database, initDefaultData, generateUniqueID } from "@/utils/db.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      navData: defaultNav,
      opacity: 1,
      database: null,
      databaseVersion: 1,
      categories: [],
      dialogVisible: false,
      form: {
        name: "",
        desc: "",
        link: "",
        icon: "",
        sort: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入网站名称", trigger: "blur" }],
      },
    };
  },
  computed: {},
  watch: {},
  filters: {},
  methods: {
    scrolling() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.opacity = 1 - scrollTop / 200;
      let el = document.getElementsByClassName("fixed-category")[0];
      if (scrollTop > 850) {
        el.classList.remove("fade-out-right");
        el.classList.add("fade-in-right");
      } else {
        el.classList.remove("fade-in-right");
        el.classList.add("fade-out-right");
      }
    },
    // 导航到分类
    navigateTo(category) {
      this.activeNav = category.id;
      let categoryEl = document.getElementById(category.id);
      categoryEl.scrollIntoView({ behavior: "smooth" });
    },
    async getCategories() {
      // 查询
      let result = await database.bookmark.where({ type: 1 }).toArray();
      // .sortBy("name")
      // .toArray();
      this.categories = result;
    },
    // 添加分类
    addCategory() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          database.bookmark
            .add({
              id: generateUniqueID(),
              name: this.form.name,
              desc: "",
              pid: 0,
              type: 1,
              link: "",
              icon: "",
              sort: 0,
              createTime: new Date(),
            })
            .then(() => {
              this.getCategories();
              this.dialogVisible = false;
            });
        }
      });
    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.scrolling);
    initDefaultData().then(() => {
      this.getCategories();
    });
    this.getCategories();
  },
};
</script>

<style lang="less">
#app {
  height: 100%;
  width: 100%;
  .wrap {
    width: 100%;
    height: 100vh;
    background-image: url("./assets/images/work.gif"),
      url("./assets/images/chengxuyuan.gif");
    background-size: 272px auto, 150px auto;
    background-repeat: no-repeat;
    background-position: left bottom, right bottom;
    .header {
      display: flex;
      padding: 30px 8.33%;
      justify-content: space-between;
      align-items: center;
      height: 130px;
      .logo {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          margin-right: 10px;
        }
        .logo-text {
          font-weight: 900;
          font-size: 14px;
          position: relative;
          &::after {
            content: "Beta";
            position: absolute;
            right: -40px;
            padding: 2px 4px;
            border-radius: 3px;
            background-color: #ff7bda;
            font-size: 12px;
          }
        }
      }
      nav {
        text-transform: uppercase;
        letter-spacing: 2px;
        font-size: 12px;
        ul {
          li {
            display: inline-block;
            margin-left: 20px;
            a {
              color: inherit;
              text-decoration: none;
              letter-spacing: 2px;
              color: #fff;
              transition: color 0.2s ease;
              padding: 3px 0;
              margin-bottom: 10px;
              position: relative;
              display: inline-block;
              &::before {
                content: "";
                position: absolute;
                top: calc(100% + 5px);
                width: 0;
                right: 0;
                height: 3px;
                transition: width 0.25s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;
                background: #845ec2;
              }
              &::after {
                content: "";
                position: absolute;
                top: calc(100% + 5px);
                width: 0;
                right: 0;
                height: 3px;
                transition: width 0.2s cubic-bezier(0.29, 0.18, 0.26, 0.83);
                background: #2fffad;
              }
              &:hover {
                &::before,
                &::after {
                  width: 100%;
                  left: 0;
                }
              }
            }
          }
        }
      }
    }
    .title {
      visibility: visible;
      transform: translateY(0) scale(1);
      opacity: 1;
      transition: transform 1s cubic-bezier(0.6, 0.2, 0.1, 1) 0.15s,
        opacity 1s cubic-bezier(0.6, 0.2, 0.1, 1) 0.15s;
      font-size: 34px;
      text-align: center;
      font-weight: 900;
      margin: 0 auto 30px;
      text-shadow: 2px 3px 0px rgba(150, 150, 150, 1);
      padding: 0px 8.33%;
    }
    .category {
      padding: 30px 8.33%;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      grid-gap: 24px 16px; /*每个元素和其他元素上下左右的空隙*/
      margin-bottom: 24px;
      .item {
        display: inline-block;
        position: relative;
        border-radius: 50px;
        background: #00c9b7;
        width: 180px;
        height: 50px;
        color: #fff;
        font-size: 14px;
        letter-spacing: 2px;
        cursor: pointer;
        -webkit-box-shadow: 10px 10px 14px 1px rgba(00, 00, 00, 0.2);
        box-shadow: 10px 10px 14px 1px rgba(00, 00, 00, 0.2);
        text-align: center;
        margin: 0 auto;
        -webkit-transition: all 0.5s;
        -o-transition: all 0.5s;
        transition: all 0.5s;
        text-transform: uppercase;
        line-height: 50px;
        &:hover {
          box-shadow: none;
        }
        &.add {
          background-color: rgb(132, 94, 194);
          border: 1px dashed;
        }
      }
    }
  }
  .bgnew {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-image: -webkit-gradient(
      linear,
      left bottom,
      right top,
      from(#6d327c),
      color-stop(#485da6),
      color-stop(#00a1ba),
      color-stop(#00bf98),
      to(#36c486)
    );
    background-image: -webkit-linear-gradient(
      left bottom,
      #6d327c,
      #485da6,
      #00a1ba,
      #00bf98,
      #36c486
    );
    background-image: -o-linear-gradient(
      left bottom,
      #6d327c,
      #485da6,
      #00a1ba,
      #00bf98,
      #36c486
    );
    background-image: linear-gradient(
      to right top,
      #6d327c,
      #485da6,
      #00a1ba,
      #00bf98,
      #36c486
    );
  }
  .bgnew2 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -2;
    background-image: -webkit-gradient(
      linear,
      left bottom,
      right top,
      from(#38438b),
      color-stop(#944b94),
      color-stop(#d75a88),
      color-stop(#ff7e71),
      color-stop(#ffb25f),
      to(#ffeb68)
    );
    background-image: -webkit-linear-gradient(
      left bottom,
      #38438b,
      #944b94,
      #d75a88,
      #ff7e71,
      #ffb25f,
      #ffeb68
    );
    background-image: -o-linear-gradient(
      left bottom,
      #38438b,
      #944b94,
      #d75a88,
      #ff7e71,
      #ffb25f,
      #ffeb68
    );
    background-image: linear-gradient(
      to right top,
      #38438b,
      #944b94,
      #d75a88,
      #ff7e71,
      #ffb25f,
      #ffeb68
    );
  }
  .fixed-category {
    position: fixed !important;
    right: 0;
    top: 50%;
    display: flex;
    flex-direction: column;
    // display: none;
    z-index: 9;
    transition: top 0.7s ease-out;
    width: 110px;
    opacity: 0;
    translate: 0% -50%;
    .item {
      display: inline-block;
      position: relative;
      border-radius: 50px;
      background: #00c9b7;
      width: 100px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      box-shadow: 2px 2px 4px 1px rgba(00, 00, 00, 0.2);
      text-align: center;
      margin: 0 auto;
      -webkit-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
      text-transform: uppercase;

      &:hover {
        box-shadow: none;
      }
      & + .item {
        margin-top: 8px;
      }
    }
    &.fade-in-right {
      animation: fadeInRight 1s forwards;
    }
    &.fade-out-right {
      animation: fadeOutRight 1s forwards;
    }
  }
}
@media only screen and (max-width: 900px) {
  #app {
    .wrap {
      .header {
        .effect {
          display: none;
        }
      }
      .category {
        grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
        .item {
          height: 32px;
          line-height: 32px;
          width: 100px;
          font-size: 12px;
          letter-spacing: 0;
        }
      }
    }
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
@keyframes fadeOutRight {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
</style>
